<template>
  <div>
    <el-breadcrumb separator=">" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/backHome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>走进崇艺</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="form" :model="CYform">
      <el-form-item label="标题"
      :rules="[
          { required: true, message: '标题不能为空'},
        ]">
        <el-input v-model="CYform.title"></el-input>
      </el-form-item>
      <!-- 富文本 -->
      <el-form-item :rules="[
          { required: true, message: '不能为空'},
        ]">
        <label style="color:#606266">内容</label>
        <script id="editor" type="text/plain" style="margin-right: 20px;width:100%"></script>
      </el-form-item>
    </el-form>
    <el-button class="save" type="primary" @click="save">保存</el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      CYform: {
        title: '',
      },
      config: {
        serverUrl: `http://test.api.8think.com/ueditor/php/controller.php`,
        toolbars: [[
          'fullscreen', 'source', '|', 'undo', 'redo', '|',
          'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
          'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
          'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
          'directionalityltr', 'directionalityrtl', 'indent', '|',
          'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
          'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
          'insertimage', 'emotion', 'scrawl', 'insertvideo', 'music', 'attachment', 'map', 'gmap', 'insertframe', 'insertcode', 'webapp', 'pagebreak', 'template', 'background', '|',
          'horizontal', 'date', 'time', 'spechars', 'snapscreen', 'wordimage', '|',
          'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
          'print', 'preview', 'searchreplace', 'drafts', 'help'
        ]]
      },
      dataF: '',
      id:'',
    }
  },
  methods: {
    save () {
      this.dataF = this.editor.getContent();
        this.$http.post('/admin/about/update', {
          id:this.id,
          title: this.CYform.title,
          content:this.dataF
          }).then( (res)=> {
        var code=res.data.code;
        // console.log(res)
        if (code===0){
        this.$message({
              type: 'success',
              message: '保存成功!'
                  });
        }else{
           this.$message({
               showClose: true,
                message: '请检查是否填写完整',
                type: 'error'
                  });
        }
      }).catch(function (error) {
        //  console.log(error);
     });
    }
  },
  mounted () {
    UE.delEditor('editor');
    this.editor = window.UE.getEditor('editor', this.config);
    this.editor.addListener('ready', (res) => {
          this.editor.setContent(this.dataF)
      // console.log(this.dataF);
    });
    this.$http.post('/admin/about/getInfo', {

    }).then( (res)=> {
      var code=res.data.code;
      // console.log(res.data.data.about)
      if (code===0){
        this.CYform.title=res.data.data.about.title;
        this.dataF=res.data.data.about.content;
        this.id=res.data.data.about.id
        // console.log(this.id)
        this.editor.setContent(this.dataF)
        
      }
    }).catch(function (error) {
        // console.log(error);
    });
  },
  created(){
    
  }
}
</script>
<style scoped>
.save {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/backPages/chongyi.vue